class FlixFaq extends HTMLElement {
  connectedCallback() {
    const items = Array.from(this.querySelectorAll('[data-flix-faq-item]'));
    items.forEach((item) => {
      const toggle = item.querySelector('[data-flix-faq-toggle]');
      const panel = item.querySelector('[data-flix-faq-panel]');
      if (!toggle || !panel) return;
      toggle.addEventListener('click', () => {
        const opening = panel.hidden;
        // Accordion: only one answer open at a time.
        items.forEach((other) => this._setOpen(other, other === item && opening));
      });
    });
  }

  _setOpen(item, open) {
    const panel = item.querySelector('[data-flix-faq-panel]');
    const sign = item.querySelector('[data-flix-faq-sign]');
    if (!panel) return;
    panel.hidden = !open;
    if (sign) sign.textContent = open ? '−' : '+';
  }
}
customElements.define('flix-faq', FlixFaq);
